import React from 'react'
import { format as formatDate } from 'date-fns'
import ShowMoreText from 'react-show-more-text'

import { useUserAPI } from '../../../../../providers/UserAPIProvider'
import { useEnvironment } from '../../../../../providers/EnvironmentProvider'

import AreYouSureModal from '../../../ChatModals/AreYouSureModalV2'

import useStyles from './styles'
import { CloseCircle, Edit2 } from 'iconsax-react'

const NoteV2 = ({ children, onDelete, onClick, note }) => {
  const { allUsers, loadUser } = useUserAPI()
  const { user } = useEnvironment()

  const [deleting, setDeleting] = React.useState(false)
  const [creator, setCreator] = React.useState(null)
  const [expanded, setExpanded] = React.useState(false)

  const { created_by, stamp } = note

  const time = React.useMemo(() => {
    let date = new Date()
    if (stamp) {
      date = new Date(stamp)
    }

    return formatDate(date, 'MMM d, yyyy')
  }, [stamp])

  const creatorName = React.useMemo(() => {
    if (!user) {
      return ''
    }

    // Newly added case
    if (!creator || creator.id === user.id) {
      return `${user.name} (You)`
    }

    return creator.name
  }, [creator, user])

  // Load created by user
  React.useEffect(() => {
    if (!created_by) {
      return
    }

    const creator = allUsers[created_by]
    if (creator) {
      setCreator(creator)
    } else {
      loadUser(created_by)
    }
  }, [created_by, allUsers, loadUser])

  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <ShowMoreText
          lines={2}
          more='Read more'
          less='Read less'
          className={classes.content}
          anchorClass={classes.expand}
          onClick={setExpanded}
          expanded={expanded}
          width={314}
          keepNewLines
        >
          {children}
        </ShowMoreText>

        <div onClick={() => setDeleting(true)} className='delete'>
          <CloseCircle />
        </div>

        <div onClick={onClick} className='edit'>
          <Edit2 />
        </div>

        <div className={classes.infoSection}>
          <div className={classes.info}>
            {creatorName && (
              <div className={classes.author}>
                by <span>{creatorName}</span>
              </div>
            )}

            <div>{time}</div>
          </div>
        </div>
      </div>

      {deleting && (
        <AreYouSureModal
          title='Delete Note'
          text='Are you sure want to delete this note?'
          onCancel={() => setDeleting(false)}
          onConfirm={onDelete}
          confirmText='Delete'
        />
      )}
    </>
  )
}

export default NoteV2
